import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import "./TitleListItem.css";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Badge from "react-bootstrap/Badge";

class TitleListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.titleEntered = this.titleEntered.bind(this);
    this.handleEditDone = this.handleEditDone.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);

    this.state = {
      isHovering: false,
      changingTitle: props.title.name
    };
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleDelete() {
    this.props.handleDelete(this.props.title);
  }

  titleEntered(event) {
    this.setState({
      changingTitle: event.target.value
    });
  }

  handleEditDone() {
    if (this.state.changingTitle == null || this.state.changingTitle === "") {
      toast.error("please enter a title name");
    } else if (this.props.title.name === this.state.changingTitle) {
      this.handleCancelEdit();
      return;
    } else {
      this.props.handleEditFire(this.props.title.id, this.state.changingTitle);
    }
  }

  handleCancelEdit() {
    this.props.handleEdit(null);
  }

  handleEdit() {
    this.setState({
      changingTitle: this.props.title.name
    });

    this.props.handleEdit(this.props.title.id);
  }

  renderSwitch(hasProd, deletable) {
    const linkName = hasProd
      ? `${this.props.title.name} (${this.props.title.production_title})`
      : this.props.title.name;

    const linkUri = `${process.env.REACT_APP_URL_ROOT}titles/${
      this.props.title.id
    }/pdf_books`;

    const titleAutomate =
      this.props.title != null ? this.props.title.automate : 0;

    if (this.props.title.id !== this.props.edittingTitleID) {
      return (
        <div className="title_list_item_title_container">
          <Link className="title_list_item_left_title title_link" to={linkUri}>
            <span className="fa fa-folder" /> {linkName}
            {titleAutomate >= 1 && (
              <Badge variant="warning" className="title_list_item_auto_badge">
                {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
              </Badge>
            )}
          </Link>

          {this.props.isAdmin && this.state.isHovering && (
            <ButtonGroup className="title_list_item_right_btn">
              <Button
                className="title_list_item_btn"
                variant="info"
                disabled={this.props.editLoading}
                onClick={this.handleEdit}
              >
                <span className="fa fa-edit" />
              </Button>
              {deletable && (
                <Button
                  className="title_list_item_btn"
                  disabled={this.props.editLoading}
                  variant="danger"
                  onClick={this.handleDelete}
                >
                  <span className="fa fa-trash" />
                </Button>
              )}
            </ButtonGroup>
          )}
        </div>
      );
    } else {
      return (
        <div className="title_list_item_title_container">
          <div className="title_list_item_left_title">
            <Form.Control
              autoFocus
              type="text"
              value={this.state.changingTitle}
              onChange={this.titleEntered}
            />
          </div>
          <ButtonGroup className="title_list_item_right_btn">
            <Button
              className="title_list_item_btn"
              variant="info"
              onClick={this.handleEditDone}
              disabled={this.props.editLoading}
            >
              {this.props.editLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span className="fa fa-check" />
              )}
            </Button>
            <Button
              className="title_list_item_btn"
              variant="secondary"
              onClick={this.handleCancelEdit}
              disabled={this.props.editLoading}
            >
              <span className="fa fa-times" />
            </Button>
          </ButtonGroup>
        </div>
      );
    }
  }

  render() {
    const hasProd = this.props.title.production_title != null;
    const deletable = !hasProd;

    return (
      <ListGroup.Item
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.props.titleListItemClicked}
        variant={deletable ? "secondary" : ""}
      >
        {this.renderSwitch(hasProd, deletable)}
      </ListGroup.Item>
    );
  }
}

export default TitleListItem;
